import produce from 'immer';
import { Types as matchActions } from './actions';

export const INITIAL_STATE = {
  matches: { data: [], loading: false },
  selectedMatch: { data: null, loading: false, failed: false },
  selectedMatchScore: { data: {}, loading: false },
  matchStatus: { data: { matchIsBeingPlayed: null }, loading: false },
  referee: {
    data: {},
    loading: false,
  },
  refereeAssistants: { data: {}, loading: false },
  kits: { data: {}, loading: false, failed: false },
  grassStatus: { data: {}, loading: false },
  lineup: { data: {}, loading: false, failed: false },
  events: { data: [], loading: false, failed: false },
  directStats: { data: {}, loading: false, failed: false },
  acts: {
    data: {},
    loading: false,
  },
  localSquad: { data: {}, loading: false, failed: false },
  visitorSquad: { data: {}, loading: false, failed: false },
  stats: { data: [], loading: false, failed: false },
  publicFiles: { data: {}, loading: false },
  privateFiles: { data: {}, loading: false },
};

export default function matches(state = INITIAL_STATE, action) {
  const { type, payload } = action;

  return produce(state, draft => {
    switch (type) {
      case matchActions.GET_MATCHES_REQUEST: {
        draft.matches.loading = true;
        break;
      }
      case matchActions.GET_MATCHES_SUCCESS: {
        draft.matches.data = payload.payload.dates;
        draft.matches.loading = false;
        break;
      }
      case matchActions.GET_MATCHES_FAILURE: {
        draft.matches.loading = false;
        break;
      }
      case matchActions.GET_SQUADS_REQUEST: {
        draft.localSquad.loading = true;
        draft.visitorSquad.loading = true;
        draft.localSquad.failed = false;
        draft.visitorSquad.failed = false;
        break;
      }
      case matchActions.GET_SQUADS_SUCCESS: {
        draft.localSquad.data = payload.localSquad;
        draft.visitorSquad.data = payload.visitorSquad;
        draft.localSquad.loading = false;
        draft.visitorSquad.loading = false;
        draft.localSquad.failed = false;
        draft.visitorSquad.failed = false;
        break;
      }
      case matchActions.GET_SQUADS_FAILURE: {
        draft.localSquad.loading = false;
        draft.visitorSquad.loading = false;
        draft.localSquad.failed = true;
        draft.visitorSquad.failed = true;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_REQUEST: {
        draft.selectedMatch.loading = true;
        draft.selectedMatch.failed = false;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_SUCCESS: {
        draft.selectedMatch.data = payload;
        draft.selectedMatch.loading = false;
        draft.selectedMatch.failed = false;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_FAILURE: {
        draft.selectedMatch.loading = false;
        draft.selectedMatch.failed = true;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_SCORE_REQUEST: {
        draft.selectedMatchScore.loading = true;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_SCORE_SUCCESS: {
        draft.selectedMatchScore.data = payload;
        draft.selectedMatch.loading = false;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_SCORE_FAILURE: {
        draft.selectedMatchScore.loading = false;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_STATUS_REQUEST: {
        draft.matchStatus.loading = true;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_STATUS_SUCCESS: {
        draft.matchStatus.data.matchIsBeingPlayed = payload;
        draft.matchStatus.loading = false;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_STATUS_FAILURE: {
        draft.matchStatus.loading = false;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_REFEREES_REQUEST: {
        draft.referee.loading = true;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_REFEREES_SUCCESS: {
        draft.referee.data = payload;
        draft.referee.loading = false;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_REFEREES_FAILURE: {
        draft.referee.loading = false;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_REFEREE_ASSISTANTS_REQUEST: {
        draft.refereeAssistants.loading = true;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_REFEREE_ASSISTANTS_SUCCESS: {
        draft.refereeAssistants.data = payload;
        draft.refereeAssistants.loading = false;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_REFEREE_ASSISTANTS_FAILURE: {
        draft.refereeAssistants.loading = false;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_KITS_REQUEST: {
        draft.kits.loading = true;
        draft.kits.failed = false;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_KITS_SUCCESS: {
        draft.kits.data = payload;
        draft.kits.loading = false;
        draft.kits.failed = false;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_KITS_FAILURE: {
        draft.kits.loading = false;
        draft.kits.failed = true;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_GRASS_STATUS_REQUEST: {
        draft.grassStatus.loading = true;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_GRASS_STATUS_SUCCESS: {
        draft.grassStatus.data = payload;
        draft.grassStatus.loading = false;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_GRASS_STATUS_FAILURE: {
        draft.grassStatus.loading = false;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_LINEUP_REQUEST: {
        draft.lineup.loading = true;
        draft.lineup.failed = false;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_LINEUP_SUCCESS: {
        draft.lineup.data = payload;
        draft.lineup.loading = false;
        draft.lineup.failed = false;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_LINEUP_FAILURE: {
        draft.lineup.loading = false;
        draft.lineup.failed = true;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_ACTS_REQUEST: {
        draft.acts.loading = true;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_ACTS_SUCCESS: {
        draft.acts.data = payload;
        draft.acts.loading = false;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_ACTS_FAILURE: {
        draft.acts.loading = false;
        break;
      }

      case matchActions.GET_SELECTED_MATCH_TEAM_STATS_REQUEST: {
        draft.stats.loading = true;
        draft.stats.failed = false;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_TEAM_STATS_SUCCESS: {
        draft.stats.data = payload;
        draft.stats.loading = false;
        draft.stats.failed = false;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_TEAM_STATS_FAILURE: {
        draft.stats.loading = false;
        draft.stats.failed = true;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_EVENTS_REQUEST: {
        draft.events.loading = true;
        draft.events.failed = false;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_EVENTS_SUCCESS: {
        draft.events.data = payload;
        draft.events.loading = false;
        draft.events.failed = false;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_EVENTS_FAILURE: {
        draft.events.loading = false;
        draft.events.failed = true;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_DIRECT_STATS_REQUEST: {
        draft.directStats.loading = true;
        draft.directStats.failed = false;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_DIRECT_STATS_SUCCESS: {
        draft.directStats.data = payload;
        draft.directStats.loading = false;
        draft.directStats.failed = false;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_DIRECT_STATS_FAILURE: {
        draft.directStats.loading = false;
        draft.directStats.failed = true;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_PUBLIC_FILES_REQUEST: {
        draft.publicFiles.loading = true;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_PUBLIC_FILES_SUCCESS: {
        draft.publicFiles.data = payload;
        draft.publicFiles.loading = false;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_PUBLIC_FILES_FAILURE: {
        draft.publicFiles.loading = false;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_PRIVATE_FILES_REQUEST: {
        draft.privateFiles.loading = true;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_PRIVATE_FILES_SUCCESS: {
        draft.privateFiles.data = payload;
        draft.privateFiles.loading = false;
        break;
      }
      case matchActions.GET_SELECTED_MATCH_PRIVATE_FILES_FAILURE: {
        draft.privateFiles.loading = false;
        break;
      }
      case matchActions.FLUSH_SELECTED_MATCH: {
        draft.selectedMatch = { data: null, loading: false };
        draft.selectedMatchScore = { data: {}, loading: false };
        draft.referee = {
          data: {},
          loading: false,
        };
        draft.refereeAssistants = { data: {}, loading: false };
        draft.kits = { data: {}, loading: false, failed: false };
        draft.grassStatus = { data: {}, loading: false };
        draft.lineup = { data: {}, loading: false, failed: false };
        draft.events = { data: [], loading: false, failed: false };
        draft.directStats = { data: {}, loading: false, failed: false };
        draft.acts = {
          data: {},
          loading: false,
        };
        draft.localSquad = { data: {}, loading: false, failed: false };
        draft.visitorSquad = { data: {}, loading: false, failed: false };
        draft.stats = { data: [], loading: false, failed: false };
        draft.publicFiles = { data: {}, loading: false };
        draft.privateFiles = { data: {}, loading: false };
        break;
      }
      default:
    }
  });
}
